import { ApolloClient } from '@apollo/client';
import { ApolloLink } from '@apollo/client/link';
import { OperationTypeNode } from 'graphql';

import { isAuthCloseEvent } from '@/api/errors';
import { clearSession } from '@/api/session';
import { getUserToken } from '@/shared/services/user-hash';

import { createCache } from './cache';
import { authLink } from './links/auth.link';
import { errorLink } from './links/error.link';
import { httpLink } from './links/http.link';
import { wsClient, wsLink } from './links/ws.link';

/**
 * Единственный клиент Apollo. Цепочка: ошибки → токен → подписки в сокет,
 * запросы и мутации по HTTP.
 */
export const apolloClient = new ApolloClient({
  link: ApolloLink.from([
    errorLink,
    authLink,
    ApolloLink.split(
      ({ operationType }) => operationType === OperationTypeNode.SUBSCRIPTION,
      wsLink,
      httpLink
    )
  ]),
  cache: createCache(),
  defaultOptions: {
    // Админка работает с меняющимися данными: показываем кэш сразу и тут же сверяем с сервером.
    watchQuery: { fetchPolicy: 'cache-and-network' }
  },
  devtools: { enabled: process.env.NODE_ENV !== 'production' }
});

// Сервер закрыл сокет из-за токена — сессия истекла, как при 401 по HTTP.
wsClient.on('closed', (event) => {
  if (isAuthCloseEvent(event) && getUserToken().accessToken) {
    void clearSession(apolloClient);
  }
});

// После переподключения перезапрашиваем активные запросы: события,
// пришедшие по подпискам без связи, потеряны.
wsClient.on('connected', (_socket, _payload, wasRetry) => {
  if (wasRetry) void apolloClient.refetchQueries({ include: 'active' });
});
